import axios from 'axios';

const baseUrl = '/keywords';

export default {
  getKeywords() {
    return axios.get(`${baseUrl}/`);
  },
  create(payload) {
    return axios.post(`${baseUrl}/create`, payload);
  },
  createBulk(payload) {
    return axios.post(`${baseUrl}/create-bulk`, payload);
  },
  delete(keywordId) {
    return axios.delete(`${baseUrl}/delete/${keywordId}`);
  },
};
